<div class="spinner-container">
  <ion-spinner class="spinner"
      name="crescent"></ion-spinner>
</div>